import React from 'react';
import PropTypes from 'prop-types';
import CommentsListItem from './CommentsListItem';
import { sortComments } from '../../store/utils/utils';

const CommentsList = ({ comments }) => {
  const sortedComments = sortComments(comments, false);
  return sortedComments.map(({ id }, index) => {
    return (
      <CommentsListItem
        key={id}
        id={id}
        // Gives each CommentsListItem a descending z-index to avoid
        // elements with positioned elements (FloatingMenu & MentionList)
        // from stacking incorrectly
        commentZIndex={sortedComments.length - index}
      />
    );
  });
};

CommentsList.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      // fill in
    })
  ).isRequired
};

export default CommentsList;
